"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreUsersCurrentGetAsyncSlice = void 0;
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
const _api_1 = require("../../../api/index.js");
const actions_1 = require("../_idMap/actions.js");
exports.coreUsersCurrentGetAsyncSlice = (0, xuder_1.createGetAsyncSlice)({
    httpSagaOptions: {
        successDataActionCreators: [
            (user) => (0, actions_1.updateUserReferences)([
                {
                    email: user.email,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    userId: user.id
                }
            ])
        ]
    },
    name: name_1.CoreUsersCurrentName,
    receive: true,
    request: false,
    requestHandler: _api_1.getCurrentUser,
    retainDataOnRequest: true
});
//# sourceMappingURL=get.js.map